<script setup lang="ts">
import { useIsMobile } from '@/composables/useMediaQuery'
import type { Mentor } from '@/types/mentor.types'
import { useRouter } from 'vue-router'

const isMobile = useIsMobile()
const router = useRouter()

const props = defineProps<{
  mentor: Mentor
}>()

const navigateToMentorDetail = () => {
  router.push(`/mentor/${props.mentor.idx}`)
}
</script>
<template>
  <div class="mentor-item cursor-pointer" @click="navigateToMentorDetail">
    <img class="mentor-image" :src="mentor.squareThumbnailUrl" alt="멘토 이미지" />
    <div class="mentor-info">
      <div class="mentor-info-top">
        <div class="mentor-name title-sm white">{{ mentor.name }}</div>
        <img
          v-if="!isMobile"
          class="svg-24 svg-white"
          src="@/assets/svgs/chevron_right.svg"
          alt="오른쪽 화살표"
        />
      </div>
      <div class="mentor-program body-md gray-600">{{ mentor.mainProgramName }}</div>
    </div>
  </div>
</template>

<style scoped>
.mentor-item {
  width: 100%;
}

.mentor-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mentor-info-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.mentor-image {
  min-width: auto;
  min-height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  aspect-ratio: 1/1;
  border-radius: 8px;
  margin-bottom: 20px;
}

@media (max-width: 1365px) {
  .mentor-image {
    margin-bottom: 12px;
  }
}
</style>
